

































































































import {getGuid, PlainObject} from '@labor-digital/helferlein';
import {AccordionApi} from './AccordionApi';

export default {
    name: 'BaseAccordionItem',
    inject: {
        api: {
            from: 'accordion',
            default: null
        } as unknown as AccordionApi
    },
    props: {
        /**
         * A label for this item
         */
        label: {
            type: String,
            required: true,
            default: ''
        },

        /**
         * Allows you to disable this item
         */
        disabled: {
            type: Boolean,
            default: false
        }

    },
    data()
    {
        return {
            identifier: this.$attrs.id ?? this.$vnode.key ?? getGuid('accordionItem_')
        };
    },
    computed: {
        /**
         * Returns the api instance
         */
        api(): AccordionApi
        {
            return this.tabs;
        },

        /**
         * Returns true if the parent told us that we are open
         */
        isOpen(): boolean
        {
            return this.api.isOpen(this.identifier);
        },

        /**
         * The unique id for this element
         */
        elementId(): string
        {
            return this.api.id + '_' + this.identifier;
        },

        /**
         * The list of css classes for this element
         */
        classes(): PlainObject
        {
            return {
                'accordionItem--disabled': this.disabled,
                'accordionItem--open': this.isOpen
            };
        }
    },
    methods: {
        /**
         * Public api to open this accordion item
         * @public
         */
        open()
        {
            this.api.openItem(this.identifier);
        },

        /**
         * Public api to close this accordion item
         * @public
         */
        close()
        {
            this.api.closeItem(this.identifier);
        },

        /**
         * Handles a click on the action toggle to open/close the element
         */
        onToggleClick()
        {
            if (this.isOpen) {
                this.close();
            } else {
                this.open();
            }
        },

        /**
         * Triggered when the vue transition of a single item container is started
         * @param el the html element that gets transitioned
         * @param open True if the element gets opened or false if it gets closed
         */
        onBeforeTransition(el: HTMLElement, open: boolean): void
        {
            el.style.height = el.scrollHeight + 'px';
            this.api.emit((
                              open ? 'open' : 'close'
                          ) + ':transition:start', this);
        },

        /**
         * Triggered when the vue transition of a single item container was finished
         * @param el the html element that was transitioned
         * @param open True if the element was opened or false if it was closed
         */
        onAfterTransition(el: HTMLElement, open: boolean): void
        {
            el.style.height = '';
            this.api.emit((
                              open ? 'open' : 'close'
                          ) + ':transition:end', this);
        }
    },
    mounted()
    {
        if (this.api === null) {
            throw new Error('You have to place the accordion items inside a accordion element!');
        }
        this.api.registerItem(this.identifier, this, this.disabled);
    },
    beforeDestroy()
    {
        this.api.removeItem(this.identifier);
    },
    watch: {
        disabled(n)
        {
            this.api.updateItem(this.identifier, n);
        }
    }
};
